// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__P9+62","links":"Navbar_links__ITUPL","footer":"Navbar_footer__W6tq1"};